module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_header_pin-c2c4e681351cd233bb8fc2365db18df9.svg";